export const common = {
  nav: {
    home: 'ホーム',
    services: '事業内容',
    travel: 'トラベルガイド',
    school: 'インター校留学サポート',
    company: '会社情報',
    contact: 'お問い合わせ'
  },
  hero: {
    title1: '東南アジアビジネスの',
    title2: '海外進出すべてサポート！',
    subtitle1: 'マレーシア・東南アジアでの事業展開から',
    subtitle2: 'お子様の教育まで、ワンストップでサポートします',
    cta: '無料相談を予約',
    details: 'サービス詳細を見る'
  },
  services: {
    title: 'Our Services',
    heading1: '',
    heading2: '3つの事業であなたをサポート',
    consulting: {
      title: 'ビジネスコンサルティング',
      desc: '東南アジア海外進出、海外事業運営、交渉通訳代行、不動産契約代行、AI活用コンサルティング等'
    },
    expansion: {
      title: '海外進出サポート',
      desc: '現地法人設立、ビザ取得、オフィス開設、スタッフ採用まで総合支援',
      badge: 'AI活用コンサルティング'
    },
    travel: {
      title: 'トラベルガイド',
      desc: 'KL周辺、マラッカツアー、ランカウィ島案内、カジノ&グルメ案内等',
      badge: 'KL周辺・カジノ案内'
    },
    school: {
      title: 'インター校留学サポート',
      desc: '学校見学、転入学サポート、ガーディアン等の総合支援',
      badge: '学校見学・転入学'
    }
  },
  features: {
    title: '選ばれる',
    titleHighlight: '理由',
    subtitle: '20年以上の実績と信頼',
    badge: '実績多数',
    network: {
      title: '現地ネットワーク',
      desc: '日系企業、政府関連とマレーシアでの豊富な人脈とパートナーシップ',
      value: '20社以上'
    },
    multilingual: {
      title: '多言語対応',
      desc: '日本語・英語・マレー語・インドネシア語に対応',
      value: '4ヶ国語'
    },
    support: {
      title: '24時間サポート',
      desc: '緊急時も安心のサポート体制'
    },
    success: {
      title: '成功率',
      desc: 'お客様満足度と事業成功率',
      value: '95%'
    }
  },
  about: {
    label: '/ About Us',
    title: 'yapauchi partners Corp. ',
    desc1: '東南アジア、特にマレーシアでのビジネス展開を',
    desc2: 'トータルサポートする専門コンサルティング会社です。',
    desc3: '現地での豊富な経験と人脈を活かし、お客様のビジネス成功を全力でサポートいたします。',
    years: '20+',
    yearsDesc1: '年以上の実績',
    yearsDesc2: '東南アジアビジネスサポート',
    button: '会社概要を見る'
  },
  testimonial: {
    title: '( お客様の声 )',
    rating: '4.9',
    review: 'マレーシアでの会社設立から現地スタッフ採用まで、すべてサポートいただきました。現地の商習慣や法律面でも的確なアドバイスをいただき、スムーズに事業を開始できました。',
    name: '田中様',
    company: '製造業・マレーシア進出'
  },
  cta: {
    text1: '東南アジアでの',
    text2: 'ビジネス展開を',
    text3: '私たちがサポートします',
    button: '無料相談を予約する'
  },
  footer: {
    newsletter: {
      title1: '最新情報を',
      title2: 'お届けします',
      desc: '東南アジアビジネスの最新トレンドやお役立ち情報',
      placeholder: 'メールアドレス',
      button: '登録する'
    },
    services: {
      title: 'サービス',
      consulting: 'ビジネスコンサルティング',
      travel: 'トラベルガイド',
      school: 'インター校サポート',
      ai: 'AI活用支援'
    },
    contact: {
      title: 'お問い合わせ',
      phone: '+60-133240652',
      email: 'shujinet@gmail.com',
      address: '所在地',
      location1: 'B-05-07 KM1 West\\nNo. 13, Jalan Jalil Perkasa 1, Bukit Jalil\\n57000 Kuala Lumpur, MALAYSIA',
      location2: 'No. 13, Jalan Jalil Perkasa 1, Bukit Jalil 57000 Kuala Lumpur, MALAYSIA'
    },
    social: {
      linkedin: 'LinkedIn',
      facebook: 'Facebook',
      instagram: 'Instagram'
    },
    copyright: '© 2025 Yamauchi Partners Corp.',
    privacy: 'プライバシーポリシー',
    terms: '利用規約',
    poweredBy: 'Website Builder'
  }
};